import { defineStore } from 'pinia';
import { shallowRef } from 'vue';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

export default defineStore('navigation', () => {
    const nextToConfirm = shallowRef<RouteLocationNormalizedGeneric>();

    // A pending navigation keeps a whole RouteLocation, so the previous order or patient id.
    function $reset(): void {
        console.info('reset navigation store');
        nextToConfirm.value = undefined;
    }

    return {
        nextToConfirm,
        $reset,
    };
});
